import styled from 'styled-components';
import { fontSize, fontWeight, spacing } from '@landr/maestro';

export const Wrapper = styled.div`
    font-weight: ${fontWeight('regular')};
    font-size: ${fontSize('sm')};
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    ${({ theme }): string => theme.breakpoint('sm')`
        font-size:  ${fontSize('xs')};
    `};

    > span {
        margin-right: ${spacing('xs')};
    }
    width: 100%;
`;
